import { render, staticRenderFns, recyclableRender, components } from "./selectLocation.vue?vue&type=template&id=aaf636b4&"
var renderjs
import script from "./selectLocation.vue?vue&type=script&lang=js&"
export * from "./selectLocation.vue?vue&type=script&lang=js&"
import style0 from "./selectLocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/selectLocation/selectLocation.vue"
export default component.exports